import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';

import GlobalEventService from '../../components/api/global_event/global_event.service';
import AnnounceService from '../../components/api/announce/announce.service';

import './global_event.css';

export class GlobalEventController {
  /*@ngInject*/
  constructor(moment, $mdDialog, GlobalEventService, AnnounceService) {
    this.GlobalEventService = GlobalEventService;
    this.AnnounceService = AnnounceService;
    this.moment = moment;
    this.$mdDialog = $mdDialog;

    this.announces = [];
    this.globalEvents = [];
  }

  $onInit() {
    this.AnnounceService.api.index(res => {
      this.announces = res;
    });

    this.GlobalEventService.api.index(res => {
      this.globalEvents = res;
    });
  }

  isFutureDate(date) {
    return this.moment(date).valueOf() >= new Date().valueOf();
  }

  showDialog(announce, ev) {
    this.AnnounceService.api.show({id: announce.id}, (announce) => {
      this.$mdDialog.show({
        targetEvent: ev,
        templateUrl: 'announce-dialog.html',
        controller: DialogController,
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: false,
        locals: {
          announce: announce
        }
      });

      /*@ngInject*/
      function DialogController($scope, $mdDialog, announce) {
        $scope.announce = announce;

        $scope.closeDialog = function () {
          $mdDialog.hide();
        };
      }
    }, (response) => {
      let alert = this.$mdDialog.alert()
        .title('エラー')
        .textContent('障害・メンテナンス情報を取得できませんでした')
        .ok('閉じる');
      this.$mdDialog.show(alert);
    });
  }
}

export default angular.module('leptonApp.globalEvent', [uiRouter, moment, GlobalEventService, AnnounceService])
  .component('globalEvent', {
    template: require('./global_event.html'),
    controller: GlobalEventController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/global_event/global_event.component.js